export function normalizeWebsiteUrl(value) {
  const trimmed = String(value || "").trim();
  if (!trimmed) throw new Error("Enter your website URL to continue.");

  const withProtocol = /^[a-z][a-z\d+.-]*:\/\//i.test(trimmed)
    ? trimmed
    : `https://${trimmed}`;

  try {
    const parsed = new URL(withProtocol);
    if (!["http:", "https:"].includes(parsed.protocol) || !parsed.hostname.includes(".")) {
      throw new Error();
    }
    return parsed.toString();
  } catch {
    throw new Error("Enter a valid website URL, like yourcompany.com.");
  }
}

export function buildLeadSignupPath(websiteUrl) {
  const campaignQuery = new URLSearchParams({ website: websiteUrl });
  const signupQuery = new URLSearchParams({
    website: websiteUrl,
    redirect: `/campaigns/new?${campaignQuery.toString()}`,
  });
  return `/signup?${signupQuery.toString()}`;
}
